import type { NonIndexRouteObject } from "react-router-dom";

import SDKRoute from "./SDKRoute";

export const sdkRoute: NonIndexRouteObject = {
  element: <SDKRoute />,
};
